import React from 'react';
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import SimplePressJobsList from "../../pressjobs/SimplePressJobsList";


const PalletSummaryJobs = ({jobs, maxHeight}) => {

    return (
        <SimplePressJobsList jobs={jobs ? jobs : []} maxHeight={maxHeight}/>
    )

}

export default PalletSummaryJobs;